import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../../contexts/AuthContext';
import { usePublicTheme } from '../../../../contexts/PublicThemeContext';
import './Footer.css';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();
  const { theme } = usePublicTheme();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <Link to="/" className="footer-logo-link">
              <div className="footer-logo">
                <img 
                  src="/images/CRYPXA_Footer_Logo.png" 
                  alt="Crypxa Logo" 
                  className="footer-logo-img"
                />
              </div>
            </Link>
            <p className="footer-description">
              {t('footer.description')}
            </p>
          </div>
          <div className="footer-section">
            <h4>{t('footer.quickLinks')}</h4>
            <ul>
              <li><Link to="/">{t('nav.home')}</Link></li>
              <li><Link to="/features">{t('nav.features')}</Link></li>
              <li><Link to="/about">{t('nav.about')}</Link></li>
              <li><Link to="/pricing">{t('nav.pricing')}</Link></li>
              <li><Link to="/community">{t('nav.community')}</Link></li>
              <li><Link to="/support">{t('nav.support')}</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>{t('footer.getStarted')}</h4>
            <ul>
              <li><Link to="/login">{t('nav.login')}</Link></li>
              <li><Link to="/signup">{t('nav.signUp')}</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>{t('footer.connect')}</h4>
            <div className="social-links">
              <a href="https://www.instagram.com/crypxa_/" target="_blank" rel="noopener noreferrer" className="social-link social-instagram" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.facebook.com/crypxa" target="_blank" rel="noopener noreferrer" className="social-link social-facebook" aria-label="Facebook">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="https://www.youtube.com/@Crypxa" target="_blank" rel="noopener noreferrer" className="social-link social-youtube" aria-label="YouTube">
                <i className="fab fa-youtube"></i>
              </a>
              <a href="https://www.tiktok.com/@crypxa" target="_blank" rel="noopener noreferrer" className="social-link social-tiktok" aria-label="TikTok">
                <i className="fab fa-tiktok"></i>
              </a>
              <a href="https://x.com/crypxa" target="_blank" rel="noopener noreferrer" className="social-link social-x" aria-label="X (Twitter)">
                <i className="fab fa-x-twitter"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-copyright">{t('footer.copyright')}</p>
          <div className="footer-legal-links">
            <Link to="/privacy-policy">{t('footer.privacyPolicy')}</Link>
            <Link to="/terms-conditions">{t('footer.termsConditions')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

